import {h, Fragment} from "preact"
import { useState, useEffect, useRef } from "preact/hooks"

export default function FilterSelectGrebban({ value, onChange, className, options, label }) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const [maxHeight, setMaxHeight] = useState("0px")
  const [isMobile, setIsMobile] = useState(true)

  const selectedOption = options.find(opt => opt.value === value)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024) // lg breakpoint
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  useEffect(() => {
    if (dropdownRef.current) {
      if (isMobile) {
        setMaxHeight("none") // Keep open on mobile
      } else {
        setMaxHeight(isOpen ? `${dropdownRef.current.scrollHeight}px` : "0px")
      }
    }
  }, [isOpen, isMobile])

  const handleSelect = (selectedValue) => {
    const syntheticEvent = { target: { value: selectedValue } }
    onChange(syntheticEvent)
    setIsOpen(false)
  }

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        className="flex justify-between items-center w-full px-8 py-12 lg:px-0 lg:pl-12"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={label}
      >
        <span className="min-w-max text-13-120--0.5-700 capitalize mr-4 flex">
          {label || "Select"}
          <span className="text-black-55">&nbsp;/&nbsp;</span>
          <span>{selectedOption?.label || "–"}</span>
        </span>
        <span
          className={`transition-all duration-600 ${isOpen ? "rotate-180" : "rotate-0"}`}
        >
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.5L6 5.5L11 0.500005" stroke="currentColor" stroke-width="2"></path> 
          </svg>
        </span>
      </button>

      <div
        ref={dropdownRef}
        className="relative lg:absolute bg-white top-full left-0 right-0 z-10 overflow-hidden transition-all duration-500"
        style={{ maxHeight }}
      >
        <div className="p-12">
          {options.map((option, index) => (
            <label
              key={option.value}
              htmlFor={`option-${index}`}
              className="flex items-center mb-12 last:mb-0 cursor-pointer"
            >
              <input
                type="radio"
                id={`option-${index}`}
                name="custom_select"
                value={option.value}
                checked={value === option.value}
                onChange={() => handleSelect(option.value)}
                className="hidden peer"
              />
              <span className="w-6 h-6 mr-6 bg-black hidden peer-checked:block"></span>
              <span className="text-13-120 text-black-55 peer-checked:text-13-120-600 peer-checked:text-black">
                {option.label}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  )
}
